import * as React from 'react'

import { AmpHeader } from '@thg-commerce/gravity-patterns'
import { useQuery } from '@apollo/react-hooks'
import { AmpFlyoutMenu } from '@thg-commerce/gravity-patterns/Header/FlyoutMenu'

import { i18n, useSiteDefinition } from '../../..'
import { SkipLink } from '../../SkipLink'
import { BasketQuery } from '../FullHeaderLayout'
import { BASKET, HEADER_NAVIGATION } from '../../HeaderGroup/graphql'
import { Routes } from '../../Routing/Routes'

export const AmpHeaderLayout = ({ children }) => {
  const { siteName } = useSiteDefinition()

  const { data: basketData } = useQuery<BasketQuery>(BASKET)
  const { data: headerNavigationData } = useQuery(HEADER_NAVIGATION)

  const i18nHeaderText = {
    logoLinkAriaLabel: i18n('header.logo.arialabel', siteName),
    flyoutMenuAriaLabel: i18n('header.menu.button.arialabel'),
    searchPlaceholder: i18n('header.search.placeholder'),
    accountLabel: i18n('header.account.label'),
    basketLabel: i18n('header.basket.label'),
  }

  const i18nFlyoutText = {
    closeAriaLabel: i18n('general.modal.close.button.arialabel'),
    contactUsText: i18n('header.submenu.link1.text'),
    contactUsLink: i18n('header.submenu.link1.link'),
    helpText: i18n('header.submenu.link2.text'),
    helpLink: i18n('header.submenu.link1.link'),
    homeLabel: i18n('header.logo.arialabel', siteName),
    subMenuAriaLabel: i18n('header.submenu.arialabel'),
    backText: i18n('header.flyout.button.back.text'),
    linkWithChildren: i18n('header.flyout.linkwithchildren.arialabel'),
    homeTemplate: i18n('header.flyout.sectionhome.text'),
  }

  return (
    <React.Fragment>
      <header>
        <SkipLink />
        <AmpHeader
          itemsInBasket={basketData?.basket.totalQuantity}
          uris={{
            basket: Routes.Basket,
            search: Routes.Search,
            account: Routes.AccountHome,
            home: Routes.HomePage,
          }}
          i18n={i18nHeaderText}
        />
      </header>
      <AmpFlyoutMenu
        uniqueGlobalIdentifier="flyoutmenu"
        navigationTree={headerNavigationData?.header}
        i18n={i18nFlyoutText}
        uris={{
          home: Routes.HomePage,
        }}
      />
      <main id="main-content">{children}</main>
    </React.Fragment>
  )
}
